export default __webpack_public_path__ + "static/media/1.c16f5607.png";